import Loadable from 'react-loadable'
import Loading from '../../components/Loading/Loading'

const SignUp = Loadable({
  loader: () => import('./containers/SignUpContainer'),
  loading: Loading,
})

export default {
  path: '/signup',
  component: SignUp,
}



// WEBPACK FOOTER //
// ./src/routes/signup/index.js